// extracted by mini-css-extract-plugin
export var fullWidthButton = "_id-0";